.awards-container-padding {
  padding: 0 15px;
}

.product-awards-block:hover.url-available {
  cursor: pointer;
}

.awards-item_name {
  line-height: 22px;
  margin-top: 38px;
  margin-bottom: 0px;
}

.awards-item_name.url-available:hover {
  text-decoration: underline;
}

.awards-item_description {
  font-size: 15px;
  line-height: 1.3333333333;
  font-weight: 400;
}

.awards-item_logo {
  width: 100px;
  height: 100px;
}